import { useMemo } from 'react';
import QACards from './QACards';
import QAPieChart from './QAPieChart';
import ErrorCategoryChart from './ErrorCategoryChart';
import ScopeQuality from './ScopeQuality';
import ClientQualityGraph from './ClientQualityGraph';
import ErrorStatusGraph from './ErrorStatusGraph';
// import QAPerformanceReportsFilter from '../PerformanceTab/QAPerformanceReportsFilter';
import { useState } from 'react';

const QualityReports = ({ filters }) => {
  const mappedFilters = useMemo(
    () => ({
      clientId: filters.client || '',
      scopeId: filters.scope || '',
      employeeId: filters.user || '',
      startDate: filters.startDate || '',
      endDate: filters.endDate || '',
      monthYear: filters.monthYear || '',
    }),
    [filters]
  );

  return (
    <div className="min-h-screen bg-gray-200 p-8">
      {/* Page Header */}
      <div className="mb-8 text-center">{/* <h1 className="text-3xl font-bold text-[#1A2B5C]">Quality Reports</h1> */}</div>
      {/* <QAPerformanceReportsFilter isChecked={false} onFilterChange={handleFilterChange}/> */}
      {/* Cards */}
      <QACards filters={mappedFilters} />
      <QAPieChart filters={mappedFilters} />

      {/* Charts Row 1 */}
      <div className="flex flex-wrap gap-6 justify-center mt-4">
        <div className="w-full lg:w-[48%]">
          <ErrorCategoryChart filters={mappedFilters} />
        </div>
        <div className="w-full lg:w-[48%]">
          <ScopeQuality filters={mappedFilters} />
        </div>
      </div>

      {/* Charts Row 2 - Client vs Error Status */}
      <div className="flex flex-wrap gap-6 justify-center mt-6">
        <div className="w-full lg:w-[48%]">
          <ErrorStatusGraph filters={mappedFilters} />
        </div>
        <div className="w-full lg:w-[48%]">
          <ClientQualityGraph filters={mappedFilters} />
        </div>
      </div>
    </div>
  );
};

export default QualityReports;
